import { Component, ReactNode } from 'react'
import { Box, Typography, Button, Alert, Paper } from '@mui/material'
import { Refresh as RefreshIcon } from '@mui/icons-material'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: { componentStack: string }) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', p: 2 }}>
          <Paper sx={{ p: 4, maxWidth: 600 }}>
            <Typography variant="h5" gutterBottom color="error">
              Ein Fehler ist aufgetreten
            </Typography>
            <Alert severity="error" sx={{ mb: 3 }}>
              {this.state.error?.message || 'Unbekannter Fehler'}
            </Alert>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
              Bitte versuche die Seite neu zu laden. Wenn das Problem weiterhin besteht, überprüfe deine
              Excel-Datei auf ungültige Daten oder Formate.
            </Typography>
            <Button
              variant="contained"
              startIcon={<RefreshIcon />}
              onClick={() => window.location.reload()}
            >
              Neu laden
            </Button>
          </Paper>
        </Box>
      )
    }

    return this.props.children
  }
}
